module.exports = __webpack_public_path__ + "img/sixpackcarrier86.b3ff4dfb.jpg";